<template>
  <div><a-table :columns="columns" :data-source="datas"   :pagination="pagination" rowKey="id"
  >
    <template slot="score_num" slot-scope="text"><span :class="[text*1>0 ? 'red' : 'green' ]"> <span v-if="text*1>0">+</span>{{ text }}</span></template>
  </a-table></div>
</template>

<script>
import API from "../api"

const columns = [
  {
    title: "来源",
    dataIndex: "source",
    key: "source",
    width: "300px",
    ellipsis: true,
  },
  {
    title: "积分变化",
    dataIndex: "score_num",
    ellipsis: true,
    key: "score_num",
    scopedSlots: {customRender: "score_num"}
  },
  {
    title: "日期",
    dataIndex: "audit_text",
    ellipsis: true,
    key: "audit_text",
    scopedSlots: {customRender: "audit_text"}
  },
];
export default {
  name: "details",
  data(){
    return{
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      datas: [],
      columns:columns,
    }
  },mounted() {
    this.getList()
  },
  methods:{
      getList(page) {
        API.service.GET_LIST_DETAILS({page: page || 1, id:this.$route.query.id}).then(res => {
          this.datas = res.data.data.list.data
          this.pagination.total = res.data.data.list.total
          this.pagination.pageSize = res.data.data.list.per_page
          this.pagination.current = res.data.data.list.current_page
          this.$store.state.company = res.data.data.company;
          this.loading = false
        })
      },} ,
  components:{ }
}
</script>

<style scoped>
.green{color: green}
.red{color: red}
</style>
